import { render, staticRenderFns } from "./DetailUserComponent.vue?vue&type=template&id=25ecdb66&scoped=true"
import script from "./DetailUserComponent.vue?vue&type=script&lang=js"
export * from "./DetailUserComponent.vue?vue&type=script&lang=js"
import style0 from "./DetailUserComponent.vue?vue&type=style&index=0&id=25ecdb66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ecdb66",
  null
  
)

export default component.exports